// extracted by mini-css-extract-plugin
export default {"form":"EditGoalHierarchy_form__TFIpq","treeEditorWrapper":"EditGoalHierarchy_treeEditorWrapper__N2q8L"};